<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <span class="bold">Disposition Analysis</span>
        </div>
        <div class="row ">
            <div class="col-sm-3">
                <mat-form-field appearance="fill">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate #dateRangeStart placeholder="Start date">
                        <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChangeDispoAnalysis(dateRangeStart, dateRangeEnd)">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <mat-icon (click)="clearDate()">clear</mat-icon>
            </div>
            <div class="col-sm-2 mt-2" >
                <mat-select  placeholder="Circle"  [(ngModel)]="circle" (click)="setSearchValue('circle')" multiple>
                    <input class="mySearchInput"
                    #circleSearch focused="'true'" type="text"
                    (keyup)="searchOnSelect($event.target.value, 'circle')"
                    (keydown)="$event.stopPropagation()" autocomplete="off"
                    placeholder="Search"
                    id="circleSearch">
                    <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-2 mt-2">
                <mat-select  placeholder="Lead Status"  [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                    <input class="mySearchInput"
                    #lead_status_Search focused="'true'" type="text"
                    (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                    (keydown)="$event.stopPropagation()" autocomplete="off"
                    placeholder="Search"
                    id="lead_status_Search">
                    <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-5 mt-2">
                <button type="button" class="btn btn-primary mb-4" (click)="getDispositionAnalysisDataMet()"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                <!-- <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="disposition_analysis_loading" (click)="exportDispositionAnalysisReport()"><i class="fa fa-file-excel"></i> Export List</button> -->
          </div>
        </div>
        <div class="row row-cards mt-2">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
                        <thead>
                            <tr class="text-center">
                                <th colspan="3"><b>Disposition Analysis Report</b></th>
                            </tr>
                            <tr class="text-center">
                                <th>Status/Disposition</th>
                                <th>Total Lead Count</th>
                                <th>Contribution %</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngFor="let tdata of analysis_arr" >
                                <td>{{tdata.status_name}}</td>
                                <td>{{tdata.total_status_wise_lead}}</td>
                                <td>
                                    <span *ngIf="(tdata.total_status_wise_lead/total_leads)*100">{{(tdata.total_status_wise_lead/total_leads)*100 | number : '1.2-2'}}%</span>
                                    <span *ngIf="!(tdata.total_status_wise_lead/total_leads)*100">0%</span>
                                </td>
                            </tr> 
                            <tr *ngIf="disposition_analysis_loading">
                                <td colspan="3" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                            </tr>
                            <tr class="text-center">
                                <td><b>Total</b></td>
                                <td><b>{{total_leads}}</b></td>
                                <td><b>
                                    <span *ngIf="total_contribution">{{total_contribution | number : '1.0-0'}}%</span>
                                    <span *ngIf="!total_contribution">0%</span>
                                </b></td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
            </div>
        </div> 
    </div>
</div>

